import { createStore } from 'vuex'
import user from '@/store/modules/user'
import dict from '@/store/modules/dict'
import news from '@/store/modules/news'
import request from '@/store/modules/request'
import webviewCall from '@/utils/webviewCall'


const store = createStore({
  modules: {
    user,
    dict,
    news,
    request,
  }
})



export default store
